export default __webpack_public_path__ + "static/media/locations.3cb49ccc.svg";